import { frontendConfigure } from "@spark/frontend-config";
import type { FrontendConfig } from "../../domain/index.ts";

export const getConfig = frontendConfigure<FrontendConfig>();
